import axios from "axios";
import { rememberReturnTo } from "./returnTo";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("map_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("map_token");
      localStorage.removeItem("map_user");
      // Seul l'espace équipe (/app) renvoie à la connexion : un jeton équipe expiré ne doit jamais sortir un membre
      // de /membres ni d'une page publique (le membre a son propre jeton, géré par memberApi).
      const p = window.location.pathname;
      if (p === "/app" || p.startsWith("/app/")) {
        rememberReturnTo(p + window.location.search + window.location.hash);
        window.location.href = "/auth";
      }
    }
    return Promise.reject(err);
  }
);

// === Univers MEMBRES — client séparé (token membre, jamais mêlé au token admin) ===
export const memberApi = axios.create({ baseURL: API });
memberApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("member_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
